import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-loader-audio',
    templateUrl: './loader-audio.component.html',
    styleUrls: ['./loader-audio.component.scss'],
    standalone: false
})
export class LoaderAudioComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
